import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { boldFont, textSize, color } from '@portal/kit/pkg/styles'

import { withRanIcon, ranIcon, withDesktopRanIcon, desktopRanIcon } from 'styles/helpers'

const ranStyles = createUseStyles(theme => ({
  helpButton: {
    position: 'relative',
    display: 'block',
    ...color('textDefault'),
    ...boldFont(),
    ...withRanIcon(),
  },
  helpButtonIcon: {
    ...ranIcon(theme),
  },
  helpButtonArrow: {
    position: 'absolute',
    fontSize: 14,
    right: 4,
  },
  activateTitle: {
    ...textSize(14, 19),
    ...boldFont(),
  },
  activateText: {
    marginBottom: 16,
    ...textSize(14, 19),
  },
  activateAction: {
    textAlign: 'right'
  },
  activateWrapper: {},

  [config.mediaQueries.tabletPortrait]: {
    helpButton: {
      ...withDesktopRanIcon(),
    },
    helpButtonIcon: {
      ...desktopRanIcon(),
    },
    helpButtonArrow: {
      right: 10,
    },
    activateWrapper: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    activateText: {
      marginBottom: 0,
    }
  }
}))

export default ranStyles
